export const Image_Type= ["image/png","image/jpeg", "image/jpg"]